module.exports = __webpack_public_path__ + "fonts/400-italic-greek-ext.6038b6b.woff2";